module.exports = __webpack_public_path__ + "img/bhDfjzeFhyKY3QhLaSgdI1eSmJM7lAYFTpVZ1n7Z.225cf983.jpg";